module.exports = __webpack_public_path__ + "static/JavaScript-3812df5e6e7961e222ae9e3e9ccf0ac7.svg";